import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InfoIcon = ({ title, subTitle, icon }) => (
  <>
    <StyldTitle>{title}</StyldTitle>
    <StyldSubTitle>{subTitle}</StyldSubTitle>
    <StyledImg src={icon} />
  </>
);

const StyldTitle = styled.div`
  font-size: 14px;
  color: #748aa1;
`;

const StyldSubTitle = styled.div`
  font-size: 11px;
  color: #748aa1;
  margin-top: 4px;
`;

const StyledImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 12px;
  max-width: 100%;
`;

InfoIcon.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  icon: PropTypes.string.isRequired
};

export default InfoIcon;
